// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.page-header[data-v-3b5a743a]{\n  margin-bottom: 24px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #eaeefb;\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
